import { VFC } from 'react';
import { Card, Col, Form, Input, message, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { FormattedMessage, useIntl } from 'react-intl';
import { getInstallationTechnologyButtonConfig } from 'routes/installation/const/config/installationTechnology';
import { QrReader } from '../../../../components/qr_reader/QrReader';
import { FORM_LAYOUT_CONFIG } from '../../../../consts/common';
import { FormItem } from '../../../../components/Form/FormItem';
import { useStore } from '../../useStore';
import type { SensorScanForm } from './slice';
import { useInstallMeterStepsStore } from '../../components/store';
import { InstallationTechnology } from '../../const/installationTechnology';
import { SensorScanStepContent as messages } from './messages';

export const SensorScanStepContent: VFC = () => {
  const { setSensorScanStepValues, dataSourceId, installationTechnology } = useStore();
  const { setNextStep } = useInstallMeterStepsStore();
  const [form] = Form.useForm<SensorScanForm>();
  const intl = useIntl();

  const { serialName } = getInstallationTechnologyButtonConfig(
    intl,
    installationTechnology ?? InstallationTechnology.LoraWan,
  );

  const handleScan = (result: string | null) => {
    if (result) {
      form.setFieldsValue({ dataSourceId: result });
      setSensorScanStepValues({ dataSourceId: result });
      message.success(intl.formatMessage(messages.scanSuccess));
    }
  };

  const handleValuesChange = (changedVals: SensorScanForm) => {
    setSensorScanStepValues(changedVals);
  };

  const handleFinish = () => {
    setNextStep();
  };

  return (
    <Card bodyStyle={{ padding: 0 }} bordered={false}>
      <Title level={5} style={{ textAlign: 'center' }}>
        <FormattedMessage {...messages.title} values={{ serialNumber: serialName.lowerCase }} />
      </Title>
      <Form
        form={form}
        id="sensorScanStepForm"
        layout="horizontal"
        name="basic"
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
        {...FORM_LAYOUT_CONFIG}
      >
        <Row justify="center">
          <Col xl={20} xs={24}>
            <QrReader onScan={handleScan} />
          </Col>
        </Row>
        <FormItem
          initialValue={dataSourceId}
          label={serialName.titleCase}
          name="dataSourceId"
          rules={[
            {
              required: true,
              message: intl.formatMessage(messages.datasourceIdRequired, { serialName: serialName.lowerCase }),
            },
          ]}
        >
          <Input placeholder={intl.formatMessage(messages.dataSourcePlaceholder)} />
        </FormItem>
      </Form>
    </Card>
  );
};
